import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info-admin",
  "use": "info-admin-usage",
  "viewBox": "0 0 16 16.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16.02\" id=\"info-admin\"><defs><style>#info-admin .cls-1{fill:none}</style></defs><title>消息管理</title><g id=\"info-admin_图层_2\" data-name=\"图层 2\"><g id=\"info-admin_图层_1-2\" data-name=\"图层 1\"><path id=\"info-admin_Rectangle_45_Copy_13\" data-name=\"Rectangle 45 Copy 13\" class=\"cls-1\" d=\"M0 .02h16v16H0z\" /><g id=\"info-admin_bells\"><path id=\"info-admin_Shape\" d=\"M8 16a1.13 1.13 0 0 1-1.12-1.13v-.75H2.56a.56.56 0 0 1-.56-.56.57.57 0 0 1 .56-.56H3V6a5 5 0 0 1 4.4-5V.58A.56.56 0 0 1 7.92 0a.57.57 0 0 1 .59.53v.52A5 5 0 0 1 12.9 6v7h.43a.56.56 0 0 1 0 1.12H9.06v.75A1.12 1.12 0 0 1 8 16zM8 2.14A3.87 3.87 0 0 0 4.11 6v7h7.68V6A3.87 3.87 0 0 0 8 2.14z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/info-admin.svg
// module id = lIef
// module chunks = 6